import Button from './components/button'

export {Button}

const vsUi = {
  Button,
}

vsUi.install = function(Vue, options = {}) {
  Vue.component('tvb-button', Button)
  // 组件多时，改用循环来写...
}
export default vsUi
